
export class CancelInvoiceDetail {
  id: number;
  invoiceCancellationId: number;
  economicActId: number;
}
